import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

interface MUISelectProps {
  values: { [key: string]: any }[];
  labelField: string;
  valueField: string;
  label: string;
  onSelect: (value: { [key: string]: any }) => void;
  value: string;
  fullWidth: boolean;
  disabled: boolean;
}
export default function MuiSelect(props: MUISelectProps) {
  const {
    values,
    labelField,
    valueField,
    label = "",
    onSelect: handleSelect,
    value: defaultValue = "",
    fullWidth = false,
    disabled = false,
  } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultValue);
  const [open, setOpen] = React.useState(false);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>,
    child: React.ReactNode
  ) => {
    const selectedValue = event.target.value;
    if (typeof selectedValue === "string") {
      let foundObj = values.find(
        (value) => value[valueField] === selectedValue
      );

      if (typeof handleSelect === "function") {
        // console.log("foundObj", foundObj);
        if (!foundObj) {
          foundObj = { [labelField]: "", [valueField]: "" };
        }
        handleSelect(foundObj);
      }

      setValue(selectedValue);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (typeof defaultValue === "string") {
      setValue(defaultValue);
    } else if (typeof defaultValue === "object" && defaultValue[valueField]) {
      setValue(defaultValue[valueField]);
    }
  }, [defaultValue, valueField]);

  return (
    <div>
      <FormControl className={classes.formControl} fullWidth={fullWidth}>
        <InputLabel>{label}</InputLabel>
        <Select
          disabled={disabled}
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={value}
          onChange={handleChange}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          }}
        >
          {/* show none selection only when value === "", ie: on mounted */}
          {value === "" && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {values.map((ele, index) => {
            const value = ele[valueField];
            const label = ele[labelField];
            return (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}
